import React from 'react'

const ViewBarArrowTimeDown = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.3 28.3">
    <path
      d="M19.1 2.6c-4.1 0-7.4 3.3-7.4 7.4s3.3 7.4 7.4 7.4 7.4-3.3 7.4-7.4-3.3-7.4-7.4-7.4zM23 13.9l-4.8-3V5.3h1.4v4.8l4.2 2.5-.8 1.3z"
      fill="none"
    />
    <path d="M12.7 20.8c-.4-.4-1.2-.4-1.6 0l-3.5 3.5V1.4C7.6.8 7.1.3 6.5.3c-.6 0-1.1.5-1.1 1.1v22.8l-3.5-3.5c-.4-.4-1.2-.4-1.6 0-.2.3-.3.6-.3.9 0 .3.1.6.3.8l5.4 5.4c.2.2.5.3.8.3.3 0 .6-.1.8-.3l5.4-5.4c.2-.2.3-.5.3-.8 0-.3-.1-.6-.3-.8z" />
    <path d="M19.1.7C14 .7 9.8 4.9 9.8 10s4.2 9.3 9.3 9.3c5.1 0 9.3-4.2 9.3-9.3S24.2.7 19.1.7zm0 16.7c-4.1 0-7.4-3.3-7.4-7.4s3.3-7.4 7.4-7.4 7.4 3.3 7.4 7.4-3.3 7.4-7.4 7.4z" />
    <path d="M19.6 5.3h-1.4v5.6l4.8 3 .7-1.2-4.1-2.5z" />
  </svg>
)

export default ViewBarArrowTimeDown
